import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadInfoBarComponent } from './load-info-bar.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { StatusCodeModule } from '../status-code/status-code.module';
import { TransportModeModule } from '../transport-mode/transport-mode.module';
import { MonitoringDatesModule } from '../monitoring/dates/monitoring-dates.module';
import { LoadInfoBarHeaderDatesComponent } from './load-info-bar-header-dates/load-info-bar-header-dates.component';
import { LoadInfoBarHeaderDefaultComponent } from './load-info-bar-header-default/load-info-bar-header-default.component';
import { DeviationTypeModule } from '../deviation-type';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [LoadInfoBarComponent, LoadInfoBarHeaderDatesComponent, LoadInfoBarHeaderDefaultComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    IntrackFeatureModule,
    StatusCodeModule,
    TransportModeModule,
    MonitoringDatesModule,
    DeviationTypeModule,
    SvgIconModule,
  ],
  exports: [LoadInfoBarComponent, LoadInfoBarHeaderDatesComponent, LoadInfoBarHeaderDefaultComponent],
})
export class LoadInfoBarModule {}
